import React, { forwardRef } from 'react';
import { Icon } from '@modulor/react';
import classNames from 'classnames';
import Button from '../../ui-components/Button/Button';
import { getDataTestAttributes } from '../../../utils/testing-locators';
import {
  SLIDER_ARROW_NEXT,
  SLIDER_ARROW_PREVIOUS,
} from '../../../constants/dataTestIds';

import styles from './SliderArrows.module.css';

const DEFAULT_ICON_SIZE = 32;

const DIRECTION_LEFT = 'left';

const Arrow = forwardRef(
  (
    { onClick, disabled, direction = DIRECTION_LEFT, className, iconSize },
    ref
  ) => {
    const isLeftDirection = direction === DIRECTION_LEFT;

    return (
      <Button
        onClick={onClick}
        disabled={disabled}
        className={classNames(
          styles.button,
          {
            [styles.left]: isLeftDirection,
            [styles.right]: !isLeftDirection,
          },
          className
        )}
        {...getDataTestAttributes(
          isLeftDirection ? SLIDER_ARROW_PREVIOUS : SLIDER_ARROW_NEXT
        )}
        ref={ref}
      >
        <Icon
          name={isLeftDirection ? 'chevron_left' : 'chevron_right'}
          size={iconSize || DEFAULT_ICON_SIZE}
        />
      </Button>
    );
  }
);

export default Arrow;
